"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _tabsHeader = require("./__internal__/tabs-header/tabs-header.style");

var _tab = _interopRequireDefault(require("./tab/tab.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledTabs = _styledComponents.default.div`
  ${({
  position,
  inSidebar,
  theme,
  headerWidth
}) => (0, _styledComponents.css)`
    color: ${theme.text.color};

    ${position === "left" && (0, _styledComponents.css)`
      ${headerWidth && (0, _styledComponents.css)`
        ${_tabsHeader.StyledTabsHeaderWrapper} {
          width: ${headerWidth};
        }

        ${_tab.default} {
          width: auto;
        }
      `}

      ${!inSidebar && (0, _styledComponents.css)`
        display: flex;
      `}

      width: 100%;
    `}
  `}

  ${_styledSystem.margin}
`;
StyledTabs.defaultProps = {
  position: "top",
  theme: _base.default
};
StyledTabs.propTypes = {
  position: _propTypes.default.oneOf(["top", "left"]),
  hasCustomTarget: _propTypes.default.bool
};
var _default = StyledTabs;
exports.default = _default;